import React, { useState, useEffect } from "react";
import { Accordion, Button, Container, Grid, Icon } from "semantic-ui-react";

import rightArrow from "../../../images/right-arrow.svg";
import paperfliteIcon from "../../../images/paperflite.svg";
import moment from "moment";

import {
  CHANGE_ACCOUNT_SUBSCRIPTION,
  PAPERFLITE_ERROR,
  UPLOAD_SSO_CONFIGURATION,
  SIGNIN_AS_USER,
  UPDATE_ACCOUNT,
  CREATE_USER,
  ACTIVATED_USER,
  ACCOUNT_SETTINGS_CHANGE,
  RESET_PASSWORD,
  UPDATE_USER,
  GENERATED_FOR_USER,
  REQUESTED_USER,
  RESEND_USER_INVITATION,
  DELETE_USER_INVITATION,
  EXTEND_INVITATION_LIMIT,
  EXTEND_TRIAL
} from "constants/appConstants";
import { fetchLogs, fetchMetrics, fetchUserMetrics } from "actions/auditLogs";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "components/ui/InfiniteScroll";

import _ from "lodash";
import cx from "classnames";
import styles from "./auditLogs.module.scss";
import { resendInvitation } from "actions/invitations";

export default function AuditLogs({ account }) {
  const dispatch = useDispatch();
  const [activeItem, setActiveItem] = useState(null);
  const [logEvents, setLogEvents] = useState({});
  const [page, setPage] = useState(0);

  const logs = useSelector((state) => _.get(state, "auditLogs.logs.items", []));
  const metrics = useSelector((state) => _.get(state, "auditLogs.metrics", []));
  const userMetrics = useSelector((state) =>
    _.get(state, "auditLogs.userMetrics.items", [])
  );

  const loading = useSelector((state) =>
    _.get(state, "auditLogs.logs.loading")
  );
  const currentPage = useSelector((state) =>
    _.get(state, "auditLogs.logs.currentPage")
  );

  const totalPages = useSelector((state) =>
    _.get(state, "auditLogs.logs.totalPages")
  );

  const totalRecordsCount = useSelector((state) =>
    _.get(state, "auditLogs.logs.totalRecordsCount")
  );

  const renderInitials = (user) => {
    let initial = "";
    initial = user.toString().charAt(0);

    if (user.firstName) {
      initial = user.firstName.charAt(0);
    }
    if (user.lastName) {
      initial = initial + user.lastName.charAt(0);
    }

    return initial.toUpperCase();
  };

  const subscriptionContent = (event, index) => {
    return (
      <div key={index} className={cx(styles.userActivity)}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionContent}>
          <span className={styles.description}>
            {event.changedBy.name} changed the Subscription Status
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>

        <div className={styles.meta}>
          <Button className={cx(styles.btn, styles.trial)}>
            <span className={cx(styles.text)}>
              {event.previous_subscription}
            </span>
          </Button>

          <img src={rightArrow} />
          <Button className={cx(styles.btn, styles.trial)}>
            <span className={cx(styles.text)}>
              {event.current_subscription}
            </span>
          </Button>
        </div>
      </div>
    );
  };

  const defaultContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionContent}>
          <span className={styles.description}>
            {event.changedBy.name} Extend the Invitation Limit to 54
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const paperfliteContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.paperfliteAvatar}>
            <img src={paperfliteIcon} />
          </div>
          <span className={styles.secondaryErrIcon}></span>
        </div>
        <div className={styles.descriptionContent}>
          <span className={styles.description}>
            Error occured, Unable to load assets.
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const signInAsUserContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionContent}>
          <span className={styles.description}>
            {event.changedBy.name} Signed in as
          </span>{""}
          <span className={styles.highlight}>{event.sign_in_as.name}</span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const renderUserContent = (event, item) => {
    if (item == "cleverstory"
      || item == "overrideSSOConfiguration"
      || item == "locked"
    ) {
      return `Turned ${event.changes[item] ? "ON" : "OFF"} the ${item}`;

    }
    return `Changed the ${item} from ${event.previous[item]} to ${event.changes[item]}`;
  }

  const userDetailsContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} updated the User Details
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
          <Accordion className={styles.accordion}>
            <Accordion.Title
              active={activeItem === event._id.timestamp}
              index={index}
              onClick={() => handleClick(event._id.timestamp)}
            >
              <Icon name="dropdown" />
            </Accordion.Title>
            <Accordion.Content
              className={styles.content}
              active={activeItem === event._id.timestamp}
            >
              {
                Object.keys(event.changes).map((item, index) => {
                  return (
                    <div className={styles.contentWrapper}>
                      <span className={styles.circle}></span>
                      <span className={styles.accordionContent}>
                        {
                          renderUserContent(event, item)
                        }
                      </span>
                    </div>
                  )
                })
              }
            </Accordion.Content>
          </Accordion>
        </div>
      </div>
    );
  };

  const renderAccountSettingsContent = (settings) => {
    console.log(settings)
    switch (settings) {
      case "hubEnabled":
        return "Hub";

      case "hubAdvanceEnabled":
        return "Hub Advanced";

      case "reportingEnabled":
        return "Reporting";

      case "canDownloadAsset":
        return "Download Asset";

      case "disableSampleData":
        return "Sample Data";

      case "globalContactEnabled":
        return "Global Contact";

      case "collectionOverlayEnabled":
        return "Collection Overlay";

      case "unsubscribeLinkEnabled":
        return "Unsubscribe Link";

      case "collectionSectionEnabled":
        return "Collection Section";

      case "inContentSearchEnabled":
        return "Content Search";

      case "isWhiteLabeled":
        return "White Label";

      case "isMicrosoftEditAccessEnabled":
        return "Microsoft Edit";

      case "allocadiaIntegrationEnabled":
        return "Allocadia Integration";

      case "disableGlobalImageLibrary":
        return "Global Image Library";

      case "recommendationEnabled":
        return "Recommendation";

      case "manageRoles":
        return "Manage Roles";

      case "trialBanner":
        return "Trial Banner";

      case "liveTalkEnabled":
        return "Live Talk"  

      default:
        return "";
    }
  }

  const accountSettingsContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} updated the Account Settings
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
          <Accordion className={styles.accordion}>
            <Accordion.Title
              active={activeItem === event._id.timestamp}
              index={index}
              onClick={() => handleClick(event._id.timestamp)}
            >
              <Icon name="dropdown" />
            </Accordion.Title>

            <Accordion.Content
              className={styles.content}
              active={activeItem === event._id.timestamp}
            >

              {
                Object.keys(event.account_settings_change).map((item) => {
                  return (

                    <div className={styles.contentWrapper}>
                      <span className={styles.circle}></span>
                      <span className={styles.accordionContent}>
                        {`Turned ${event.account_settings_change[item] ? "ON" : "OFF"} the ${renderAccountSettingsContent(item)}`}
                      </span>
                    </div>
                  )
                })
              }
            </Accordion.Content>
          </Accordion>
        </div>
      </div>
    );
  };

  const requestResetPasswordContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionContent}>
          <span className={styles.description}>
            {event.changedBy.name} reset the password for {event.reset_password_user.name}
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  }

  // const accountDetailsContent = (event,   index) => {
  //   return (
  //     <div
  //       key={index}
  //       className={cx(styles.userActivity, {
  //         [styles.addMargin]: canRender(event,  nextUser),
  //       })}
  //     >
  //       <span className={styles.date}>
  //         {new Date(event._id.date).toDateString()}
  //       </span>

  //       <div className={cx(styles.iconContainer)}>
  //         {canRender(event,  nextUser) && (
  //           <div className={styles.userAvatar}>
  //             <div>{renderInitials(  event.changedBy.name)}</div>
  //           </div>
  //         )}
  //         <span className={styles.secondaryIcon}></span>
  //       </div>
  //       <div className={styles.descriptionContent}>
  //         <span className={styles.description}>
  //           {  event.changedBy.name} Turned ON the Collection Section feature in
  //           Account Settings
  //         </span>
  //         <span className={styles.time}>
  //           {moment(new Date(event._id.date).toString()).fromNow()}
  //         </span>
  //       </div>
  //     </div>
  //   );
  // };

  const updateAccountContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} updated the {event.changes.name || event.changes.url}
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const createUserContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString() === new Date().toDateString()
            ? "Today"
            : new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} created a user named{" "}
            {event.created_user.name}
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const activatedUserContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name}{" "}
            {event.activated_user.activated ? "activated" : "deactivated"}{" "}
            {event.activated_user.email}
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const uploadSsoContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} uploaded SSO Configuration.
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const requestedUserContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} requested change password via email for {event.requested_user.name} .
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const generatedForUserContent = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} generated  a password link for {event.generated_for_user.name}
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };


  const resendUserInvitation = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} resent the invitation to {event.invitation.email}
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const deleteUserInvitation = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} deleted the invitation for {event.invitation.email}
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const extendInvitationLimit = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} changed the invitation limit from {event.invitationLimit} to {event.invitationLimitExtended}
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const extendTrial = (event, index) => {
    return (
      <div key={index} className={styles.userActivity}>
        <span className={styles.date}>
          {new Date(event._id.date).toDateString()}
        </span>

        <div className={cx(styles.iconContainer)}>
          <div className={styles.userAvatar}>
            <div>{renderInitials(event.changedBy.name)}</div>
          </div>
          <span className={styles.secondaryIcon}></span>
        </div>
        <div className={styles.descriptionAccContent}>
          <span className={styles.description}>
            {event.changedBy.name} {event.extended_days > 0 ? "extended" : "reduced" } the trial period by {Math.abs(event.extended_days)} days.
          </span>
          <span className={styles.time}>
            {moment(new Date(event._id.date).toString()).fromNow()}
          </span>
        </div>
      </div>
    );
  };

  const renderEventType = (events, event, index) => {
    switch (event._class) {
      case CHANGE_ACCOUNT_SUBSCRIPTION:
        return subscriptionContent(event, index);

      case PAPERFLITE_ERROR:
        // return paperfliteContent(event,   index);
        break;

      case SIGNIN_AS_USER:
        return signInAsUserContent(event, index);

      case UPDATE_USER:
        return userDetailsContent(event, index);

      case UPDATE_ACCOUNT:
        return updateAccountContent(event, index);

      case CREATE_USER:
        return createUserContent(event, index);

      case ACTIVATED_USER:
        return activatedUserContent(event, index);

      case UPLOAD_SSO_CONFIGURATION:
        return uploadSsoContent(event, index);

      case ACCOUNT_SETTINGS_CHANGE:
        return accountSettingsContent(event, index);

      case RESET_PASSWORD:
        return requestResetPasswordContent(event, index);

      case REQUESTED_USER:
        return requestedUserContent(event, index);

      case GENERATED_FOR_USER:
        return generatedForUserContent(event, index);

      case RESEND_USER_INVITATION:
        return resendUserInvitation(event, index);

      case DELETE_USER_INVITATION:
        return deleteUserInvitation(event, index);

      case EXTEND_INVITATION_LIMIT:
        return extendInvitationLimit(event, index); 
        
      case EXTEND_TRIAL:
        return extendTrial(event, index);  

      //   case CREATE_NEW_USER:
      //     return defaultContent(event);

      //   case UPLOAD_SSO_CONFIGURATION:
      default:
        console.log("default content something wernt wrong")
        return;
    }
  };

  const handleClick = (item) => {
    if (activeItem === item) {
      setActiveItem(null);
    } else {
      setActiveItem(item);
    }
  };

  useEffect(() => {
    dispatch(
      fetchLogs({
        page: page,
        limit: 20,
        filterRequest: { account: account.id.toString() },
      })
    );
    dispatch(
      fetchMetrics({ filterRequest: { account: account.id.toString() } })
    );
    dispatch(
      fetchUserMetrics({ filterRequest: { account: account.id.toString() } })
    );
  }, []);

  useEffect(() => {
    var eventLogs = {};
    logs.forEach((item, index) => {
      console.log(item);
      var currentDate = new Date(item._id.date).toDateString();

      if (eventLogs.hasOwnProperty(currentDate)) {
        return (eventLogs = {
          ...eventLogs,
          [currentDate]: [...eventLogs[`${currentDate}`], item],
        });
      }
      return (eventLogs = { ...eventLogs, [currentDate]: [item] });
    });

    setLogEvents({ ...eventLogs });
  }, [logs]);

  return (
    <Container className={styles.container}>
      <Grid className={styles.timelineGrid}>
        <Grid.Row>
          <Grid.Column className={styles.leftColumn}>
            <div className={styles.title}>Activity</div>
            {loading && <div className={styles.empty}>Loading...</div>}
            {logs.length === 0 && !loading && <div className={styles.empty}>No Logs</div>}

            <InfiniteScroll
              className={styles.logsInfiniteScroll}
              loading={loading}
              currentPage={currentPage}
              totalPages={totalRecordsCount}
              pagination={true}
              setPage={() => setPage(currentPage)}
            >
              {!loading && logs.length > 0 && (
                <>
                  {Object.values(logEvents).map((events) => {
                    return (
                      <section className={styles.timeLineWrapper}>
                        {events.map((event, index) => {
                          return renderEventType(events, event, index);
                        })}
                      </section>
                    );
                  })}
                </>
              )}
            </InfiniteScroll>
          </Grid.Column>
          <Grid.Column className={styles.rightColumn}>
            <Grid.Row>
              <Grid.Column className={styles.overviewSection}>
                <Grid.Row columns={2} className={styles.overviewRow}>
                  <Grid.Column className={styles.changesCol}>
                    <h3 className={styles.heading}>{metrics.actions}</h3>
                    <span>No of changes made</span>
                  </Grid.Column>
                  <Grid.Column className={styles.changesCol}>
                    <h3 className={styles.heading}>{metrics.error}</h3>
                    <span className={styles.description}>
                      No of error occured
                    </span>
                  </Grid.Column>
                </Grid.Row>
              </Grid.Column>

              <Grid.Column className={styles.administratorSection}>
                <h5 className={styles.heading}>Users</h5>

                {userMetrics.map((item, index) => {
                  return (
                    <div key={index} className={styles.userDetails}>
                      <div className={cx(styles.iconContainer)}>
                        <div className={styles.userAvatar}>
                          <div>{renderInitials(item.name)}</div>
                        </div>
                      </div>
                      <span className={styles}>{item.name}</span>
                    </div>
                  );
                })}
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
}
